import { render } from "./DialogTicketRefundError.vue?vue&type=template&id=106a0bec"
import script from "./DialogTicketRefundError.vue?vue&type=script&lang=js"
export * from "./DialogTicketRefundError.vue?vue&type=script&lang=js"
script.render = render

export default script